import _ from 'lodash'
import type { Experiments } from '@wix/thunderbolt-symbols'
import type { IUnfinishedTasks, IViewerHandlers } from './types'
import { isExperimentOpen } from '@wix/thunderbolt-experiments'

export const UnfinishedTasks = (
	{ viewerHandlers }: IViewerHandlers,
	experiments: Experiments = {}
): IUnfinishedTasks => {
	const isThunderboltRenderer = process.env.PACKAGE_NAME === 'thunderbolt-renderer'
	const reportWorkerUnfinishedTasks = isExperimentOpen(
		experiments,
		'specs.thunderbolt.reportWorkerUnfinishedTasksOnPageInitTimeout'
	)

	return {
		add: (name, meta) => {
			if (isThunderboltRenderer) {
				return _.noop
			}
			if (process.env.browser && !reportWorkerUnfinishedTasks) {
				return _.noop
			}
			const id = _.uniqueId()
			viewerHandlers.unfinishedTasks.add(id, name, meta)

			return () => {
				viewerHandlers.unfinishedTasks.remove(id)
			}
		},
	}
}
